import { Dates } from "src/modules/utils/shared/dates";
import { Strings } from "src/modules/utils/shared/strings";
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { CustomInitializer } from 'src/modules/sm-base/shared/custom-initializer.interface';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Column, Entity, OneToMany, Unique } from 'typeorm';
import { Holiday } from './holiday.entity';
import { SchoolType } from './school-type.enum';
import { SpecialDomain } from './special-domain.entity';
import { TeacherAdditional } from './teacher-additional.entity';

@Entity()
@Unique(["year", "isHalfYear"])
export class ClassRegisterSettings extends SmBaseEntity implements CustomInitializer {

    @Column({default: 0})
    year: number = 0;

    @Column({default: false})
    isHalfYear: boolean = false;

    @Column({nullable: true})
    @Type(() => Date)
    firstDayOfSchoolYear: Date;

    @Column({nullable: true})
    @Type(() => Date)
    lastDayOfSchoolYear: Date;

    @Column({default: ""})
    managerElementary: string = "";

    @Column({default: ""})
    managerSecondary: string = "";

    @Column({default: ""})
    managerSpecial: string = "";

    @Column({default: ""})
    managerElementary2: string = "";

    @Column({default: ""})
    managerSecondary2: string = "";

    @Column({default: ""})
    managerSpecial2: string = "";

    @Column({default: ""})
    managerBusinessUnit: string = "";

    @Column({default: ""})
    gradeLevelCoordinator: string = "";

    @Column({default: ""})
    gradeLevelCoordinator2: string = "";

    @Column("boolean", {array: true, default: []})
    bWeeks: boolean[];

    @Column("text", {array: true, default: []})
    dutyNames: string[];

    @Column("text", {array: true, default: []})
    instructionTexts: string[];

    @Column("text", {array: true, default: []})
    allowedDomains: string[];

    @OneToMany(() => SpecialDomain, o => o.settings, { cascade: true})
    @Type(() => SpecialDomain)
    specialDomains: SpecialDomain[];

    @OneToMany(() => Holiday, o => o.settings, { cascade: true})
    @Type(() => Holiday)
    holidays: Holiday[];

    @OneToMany(() => TeacherAdditional, o => o.settings, { cascade: true})
    @Type(() => TeacherAdditional)
    teacher: TeacherAdditional[];

    customInitializer(): void {
        this.holidays = Arrays.ensure(this.holidays);
        this.teacher = Arrays.ensure(this.teacher);
        this.bWeeks = Arrays.ensure(this.bWeeks);
        this.dutyNames = Arrays.ensure(this.dutyNames);
        this.instructionTexts = Arrays.ensure(this.instructionTexts);
        this.allowedDomains = Arrays.ensure(this.allowedDomains);
        this.specialDomains = Arrays.ensure(this.specialDomains);
    }

    getWeekDates(): Date[] {
        let result: Date[] = [];
        let x = Dates.startOf(this.firstDayOfSchoolYear, "week");
        while (x <= this.lastDayOfSchoolYear) {
            result.push(x);
            x = Dates.add(x, "week", 1);
        }
        return result;
    }

    getMonthDates(): Date[] {
        let result: Date[] = [];
        let x = Dates.startOf(this.firstDayOfSchoolYear, "month");
        while (x <= this.lastDayOfSchoolYear) {
            result.push(x);
            x = Dates.add(x, "month", 1);
        }
        return result;
    }

    isSchoolDay(date: Date): boolean {
        let weekDay = Dates.dayOfWeek(date);
        if (weekDay == 5 || weekDay == 6) {
            return false;
        }
        return !this.holidays.some(h => h.from <= date && h.to >= date);
    }

    isBWeek(date: Date): boolean {
        let i = 0;
        for (let week of this.getWeekDates()) {
            if (week <= date && Dates.add(week, "week", 1) > date) {
                return Arrays.getSafe(this.bWeeks, i, false);
            }
            i++;
        }
        return false;
    }

    isPlaceholderDomain(domain: string): boolean {
        return this.specialDomains.some(sd => sd.title == domain && sd.isPlaceholder);
    }

    getManagers(schoolType: SchoolType): string[] {
        return (
            schoolType == SchoolType.elementary ? [this.managerElementary, this.managerElementary2, this.managerBusinessUnit] :
            schoolType == SchoolType.secondary ? [this.managerSecondary, this.managerSecondary2, this.managerBusinessUnit] :
            schoolType == SchoolType.special ? [this.managerSpecial, this.managerSpecial2, this.managerBusinessUnit] : []).filter(s => s != "");
    }

    getTeacher(userName: string): TeacherAdditional {
        return this.teacher.find(t => Strings.equalsCi(t.userName, userName));
    }

    isGradeLevelCoordinator(userName: string): boolean {
        return this.gradeLevelCoordinator != "" && Strings.equalsCi(this.gradeLevelCoordinator, userName) ||
            this.gradeLevelCoordinator2 != "" && Strings.equalsCi(this.gradeLevelCoordinator2, userName) ||
            this.managerBusinessUnit != "" && Strings.equalsCi(this.managerBusinessUnit, userName);
    }


}